import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/supplier/_list/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/supplier/settings/supplier-categories' });
  },
});
